/*
 *  Document   : bootstrap.js
 *  Author     : pixelcave
 *  Description: Import global dependencies
 *
 */

/*
 ********************************************************************************************
 *
 * If you would like to use webpack to handle all required core JS files, you can uncomment
 * the following imports and window assignments to have them included in the compiled
 * oneui.app.min.js as well.
 *
 * After that change, you won't have to include oneui.core.min.js in your pages any more
 *
 *********************************************************************************************
 */

// Import all vital core JS files..
import jQuery from 'jquery';
import SimpleBar from 'simplebar';
import 'bootstrap';
import 'popper.js';
import 'jquery.appear';
import select2 from 'select2';
import 'chart.js';


// ..and assign to window the ones that need it
window.SimpleBar = SimpleBar;
window.$ = window.jQuery = jQuery;
global.$ = global.jQuery = jQuery;
window.select2 = select2
global.select2 = select2
